import { useState, useCallback, useEffect } from 'react';
import { isProduction } from 'utils';

export const useDeveloperToolsActivation = () => {
  const [clickCount, setClickCount] = useState(0);
  const [isVisible, setIsVisible] = useState(!isProduction());

  const handleLogoClick = useCallback(() => {
    // Only count clicks in production
    if (!isProduction()) {
      return;
    }
    setClickCount((prevCount) => prevCount + 1);
  }, []);

  useEffect(() => {
    if (clickCount >= 10) {
      setIsVisible(true);
    }
  }, [clickCount]);

  return { isVisible, handleLogoClick };
};
